<div class="sentiment-container">
  <span
    [style.color]="scoreIndex ? range[scoreIndex]?.color : 'black'"
    [innerHTML]="score !== undefined ? range[scoreIndex]?.char : ''"
    [ngClass]="score === undefined ? 'icon-big-robot' : ''">
  </span>
  {{ score }}
</div>
